
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedHalfRight as ObiSpeedHalfRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-half-right.js';
 
 
 

 
 export const ObiSpeedHalfRight = createComponent({
   react: React,
   tagName: 'obi-speed-half-right',
   elementClass: ObiSpeedHalfRightElement,
   events: {
     
   }
  });
 
 